import { expValEquals } from '@confluence/feature-experiments';
import { fg } from '@confluence/feature-gating';

export const getIsActivityV3RecentsEnabled = () => {
	if (fg('cc-agg-migration-use-agg-endpoint')) {
		// Custom domain check not necessary when AGG migration enabled
		// as AGG plays nice with those, for these queries
		return expValEquals('confluence_activity_v3_collaborated_on_experiment', 'isEnabled', true);
	}

	// Checks if the tenant has the default domains. Activity V3 is not able to return Confluence pages for custom domain tenants
	// This check can be removed once the fix is completed: https://hello.jira.atlassian.cloud/browse/DISCO-4716
	const isDefaultDomain =
		window.location.hostname.endsWith('.atlassian.net') ||
		window.location.hostname.endsWith('.jira-dev.com');

	const isLocalhost = window.location.hostname === 'localhost';

	return (
		(isDefaultDomain || isLocalhost) &&
		expValEquals('confluence_activity_v3_collaborated_on_experiment', 'isEnabled', true)
	);
};
